import { decode, type ProbsCallback } from "./arithmetic";
import type { ModelAdapter } from "./model";

/**
 * Streaming decoder: feed compressed chunks in, get decoded byte chunks out.
 *
 * Each chunk is decoded independently (so chunk N+1 doesn't have to wait
 * on chunk N's bytes to start the model context). For the demo this is
 * fine; if we ever care about better compression we can carry context
 * across chunk boundaries by passing in a primer.
 */
export class StreamDecoder {
  private readonly probs: ProbsCallback;

  constructor(private readonly model: ModelAdapter) {
    this.probs = (ctx) => model.getLogits(ctx);
  }

  async decodeChunk(compressed: Uint8Array, expectedLen: number): Promise<Uint8Array> {
    return decode(compressed, this.probs, expectedLen, this.model.contextWindow);
  }
}
